import { motion } from "framer-motion";
import { Check } from "lucide-react";
import CoupleAccent from "@/components/CoupleAccent";

const PROMISES = [
  "the thing you asked me not to do — i'll never do it again. period.",
  "your needs come first. you won't have to ask twice, or even once.",
  "i'll listen the way you deserve — with attention, not defensiveness.",
  "i'll be the person you fell in love with, and better than him too.",
  "if i ever feel that old pattern creeping in, i'll stop, and choose you.",
  "i'll earn your trust back slowly, quietly, every single day.",
];

export const Promises = () => {
  return (
    <section
      data-testid="promises-section"
      className="relative py-24 sm:py-32 px-6 sm:px-12"
    >
      <CoupleAccent
        src="/couple/hug.png"
        alt="us hugging"
        className="hidden md:block absolute top-16 left-4 lg:left-16 w-24 lg:w-28 -rotate-[8deg] pointer-events-none"
        float={{ y: [0, -6, 0], rotate: [-8, -4, -8] }}
        duration={5.5}
      />
      <div className="max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-14"
        >
          <p className="font-hand text-2xl text-rose-400 mb-2">
            written down, so i can be held to them
          </p>
          <h2 className="font-serif-love text-3xl sm:text-5xl text-[#3A2C2C]">
            my promises to you
          </h2>
        </motion.div>

        <ul className="space-y-4">
          {PROMISES.map((p, i) => (
            <motion.li
              key={i}
              data-testid={`promise-item-${i}`}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="flex items-start gap-4 rounded-xl border border-[#E8D8D8] bg-white/70 backdrop-blur px-5 py-4 sm:px-6 sm:py-5"
            >
              <span className="mt-0.5 w-7 h-7 shrink-0 rounded-full bg-[#F2D5D5] text-[#C28080] flex items-center justify-center">
                <Check className="w-4 h-4" strokeWidth={2.5} />
              </span>
              <p className="font-body-love text-[15px] sm:text-[17px] text-[#3A2C2C] leading-relaxed">
                {p}
              </p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Promises;
